import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TokenService } from '../../services/auth/token.service';

export const authGuard: CanActivateFn = async () => {
  const tokenService = inject(TokenService);

  return !!(tokenService && tokenService.accessToken && tokenService.accessToken !== '');
};
